<template>
<div id="fiberglass" class="w-100 tc black">
    <div class="container w-100">
      
      <div class="relative dt w-100" :style="{ 'height': mobile ? '45vh': '80vh'}">
        <!-- <img class="w-100 banner dtc v-mid" src="https://d3fgmcoixbear.cloudfront.net/s3fs-public/sustainable%20insulation_6.jpg"/> -->
        <div class="w-100 b ph2 tc dtc white v-mid">
          <div class="f1">Cellulose Insulation </div>
          <!-- <div class="f2-ns f3 mt2">Batt & Blown Insulation</div> -->
        </div>
      </div>
      

      <div class="dt w-90-ns center ">
        <div class="w-50-ns w-100 pt4-ns pt2 pic-container" :class="[mobile ? 'dib' : 'dtc v-mid']">
          <div class="pa3"><img class="applegate" src="../assets/logos-color/applegate.png"/></div>
          <div class="pa3"><img class="insul" :style="{'max-width': mobile ? '350px' : '650px'}" src="https://www.31w.com/wp-content/uploads/2019/04/iStock-186123339_res.jpg"/></div>
          <!-- <div class="pa3"><img class="sustainable" src="../assets/sustainable.png"/></div> -->
        </div>

        <div class="pt4" :class="[mobile ? 'w-90 dib' : 'w-50 lh-copy f4 dtc v-mid']">
          <div class="tl t4 bullets">
            <h3 @click="expand1 = !expand1"><span class="mt2 f3" v-if="!expand1">+</span><span v-else class="mt2 f3">-</span> USE CELLULOSE INSULATION</h3>
            <transition name="fade">
              <div v-if="expand1" class="">Cellulose is made from recycled paper products, such as newspapers or magazines. It is only installed as blow-in insulation. Its primary properties include thermal resistance and pest resistance. Cellulose insulation is sprayed or blown into walls, where it conforms to cavities and surrounds wiring and other obstacles to create a tight, monolithic thermal barrier. Fiberglass batts, on the other hand, must be cut and pieced together, leaving gaps, voids and areas of compression</div>
            </transition>
            <h3 @click="expand2 = !expand2"><span class="mt2 f3" v-if="!expand2">+</span><span v-else class="mt2 f3">-</span> WHERE TO USE CELLULOSE INSULATION</h3>
              <div v-if="expand2" class="">Cellulose insulation is an ideal insulation solution for in walls, ceilings, floors, attics, and crawl spaces in all construction types. Using cellulose insulation forms a seamless blanket of natural fibers that provide outstanding protection year round. Best of all, on the hottest and coldest days, (when you need it most) won't lose its effective R-value like traditional insulations.</div>

            <h3 @click="expand3 = !expand3"><span class="mt2 f3" v-if="!expand3">+</span><span v-else class="mt2 f3">-</span> CELLULOSE INSULATION R-VALUES</h3>
              <div v-if="expand3" class="">Applegate Insulation with an R-Value of up to 3.8 per inch, can be installed as a dense monolithic block in walls and as a blanket in the attic which significantly reduces air infiltration and acts as an effective barrier to heat transfer: 3.6-4.0 (21-26)</div>
          </div>
        </div>
      </div>

      <div class="resources black pv4-ns pv3 ">
        <div class="f3 pb4-ns pb3">Specification Sheets</div>
        <div :class="[mobile ? '' : 'dt w-90 center']">
          <div :class="[mobile ? 'pv3 w-50 center' : 'ph1 dtc v-mid']">
            <a class=" spec link ps-blue dtc v-mid" href="http://www.applegateinsulation.com/Product-Info/Insulation-Products/Stabilized-Cellulose-Insulation/default.aspx" target="_blank">
              <div class="f3">
              <img class="w-10-ns w-20" src="../assets/spec.png"/><br/>
              Stabilized Cellulose 
              </div>
            </a>
          </div>

          <div :class="[mobile ? 'pv3 w-50 center' : 'ph1 dtc v-mid']">
            <a class="spec pa4 link ps-blue dtc v-mid" href="http://www.applegateinsulation.com/Product-Info/Insulation-Products/Loose-Fill-Insulation/default.aspx" target="_blank">
              <div class="f3">
              <img class="w-10-ns w-20" src="../assets/spec.png"/><br/>
              Loose-Fill Cellulose 
              </div>
            </a>
          </div>

          <div :class="[mobile ? 'pv3 w-50 center' : 'ph1 dtc v-mid']">
            <a class="spec link ps-blue dtc v-mid" href="http://www.applegateinsulation.com/Product-Info/Insulation-Products/Bora-Spray/default.aspx" target="_blank">
              <div class="f3">
              <img class="w-10-ns w-20" src="../assets/spec.png"/><br/>
              Bora-Spray Cellulose 
              </div>
            </a>
          </div>

          <div :class="[mobile ? 'pv3 w-50 center' : 'ph1 dtc v-mid']">
            <a class="spec link ps-blue dtc v-mid" href="http://www.applegateinsulation.com/Product-Info/Insulation-Products/Speciality/default.aspx" target="_blank">
              <div class="f3">
              <img class="w-10-ns w-20" src="../assets/spec.png"/><br/>
              Speciality Cellulose 
              </div>
            </a>
          </div>
          
        </div>
        
        <div class="w-20-ns tc w-70 mt4-ns mt2 center">
        <div class="f3-ns f4 pa1">
            <a class="link" :href="info.tel">
              <div class="contact-button ps-blue b br3 bg-yellow tc pa2 link"><i class="fa fa-phone mr3" style="font-size:20px"/>Call for a quote!<div class="">{{info.phone}}</div></div>
          </a> 
        </div>
      </div>
      </div>

      
    </div>

  </div>
</template>

<script>
export default {
  name: 'Cellulose',
  props: ['info', 'mobile'],
  data() {
    return {
      expand1: false,
      expand2: false,
      expand3: false,
    };
  },
  methods: {
  },
  components: { 
  }
};
</script>

<style scoped>
.moreless {
  -webkit-filter: invert(100%); /* safari 6.0 - 9.0 */
  filter: invert(100%);
}
.spec {
  border: black 1px solid;
  padding: .5rem;
  margin: 0.5rem .5rem;
  border-radius: 2%;
  min-height: 139px;
}
.spec:hover{
  background: rgb(15,55,111);
  color: white;
}
.spec:hover img {
    -webkit-filter: invert(1);
}
h3 {
  padding: 1rem;
  border: solid black 1px;
  background: rgb(15,55,111);
  text-align: center;
  color: white;
}
#fiberglass {
  min-height: 85vh;
  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url("https://images.unsplash.com/photo-1516541196182-6bdb0516ed27?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2134&q=80");
}
.relative {
  background-image: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .5)), url("https://lirp-cdn.multiscreensite.com/aa33a071/dms3rep/multi/opt/cellulose-640x200-960w.png");
  background-repeat: no-repeat;
  background-size: cover; 
  background-position: 50% 10%;
}
.banner {
  background-image: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .7));
  max-height: 300px;
}
.absolute {
  top: 10%;
  right: 10%;
}
.applegate {
  max-height: 100px;
}
.sustainable {
  max-height: 100px;
}
.insul {
  max-width: 350px;
}
.contact-button {
  color: rgb(15,55,111) !important;
}

.contact-button:hover {
  background: rgb(15, 55, 111) !important;
  color: gold !important;
  box-shadow: gold 5px 5px !important;
  transition: .3s ease;
  border: gold 1px solid;
}

.contact-button {
  box-shadow: rgb(15,55,111) 5px 5px !important;
  background:gold 5px 5px !important;
  padding: .7rem !important;
  color: rgb(15, 55, 111) !important;
  transition: .3s ease;
}
.link {
  /* box-shadow: rgb(15,55,111) 3px 3px !important; */
  text-decoration: none;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>